module.exports = __webpack_public_path__ + "static/white-logo-girl-9873c6dd504c7133bcbe57126a3405b4.png";